import { Dropdown } from '@/modules/Dropdown';
import { LogicOperator } from '../../types/filter';

interface LogicOperatorSelectorProps {
  value: LogicOperator;
  onChange: (value: LogicOperator) => void;
}

const LOGIC_OPTIONS = [
  { value: 'and', label: 'AND' },
  { value: 'or', label: 'OR' },
];

export const LogicOperatorSelector = ({ value, onChange }: LogicOperatorSelectorProps) => {
  return (
    <div className="ui-flex ui-items-center ui-justify-center ui-py-12">
      <div className="ui-w-[74px]">
        <Dropdown
          field={{ size: 'xs' }}
          multi={{ showTriggerClearButton: false }}
          items={{
            options: LOGIC_OPTIONS,
            valueName: 'label',
            idName: 'value',
            defaultOptionSelected: false,
          }}
          values={{ value }}
          events={{ onValueChange: (val) => onChange(val as LogicOperator) }}
        />
      </div>
    </div>
  );
};
